import React, {ReactNode, useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import {useAuthorization} from "../../hooks";

interface IProtectedRouteProps {
    children: ReactNode;
    permissionType?: "vectorization" | "imageGeneration";
}

export const ProtectedRoute: React.FC<IProtectedRouteProps> = ({children, permissionType = "vectorization"}) => {
    const navigate = useNavigate();
    const {checkUserHasVectorizationPermission, checkUserHasImageGenerationPermission} = useAuthorization();

    const check = permissionType === "imageGeneration"
        ? checkUserHasImageGenerationPermission
        : checkUserHasVectorizationPermission;

    useEffect(() => {
        check().then(result => {
            if (!result) {
                navigate("/");
            }
        })
    }, [check, navigate]);
    return children;
};
